import React from 'react'
import { Form, Select } from 'antd'

const languages = require('../data/languages.json')

const FormItem = Form.Item
const Option = Select.Option

class LanguageSelection extends React.Component {
  static defaultProps = {}

  state = {
    sourceLanguage: '',
    targetLanguages: [],
  }

  handleSourceLanguageChange = sourceLanguage => {
    this.setState({ sourceLanguage, targetLanguages: [] })
  }

  handleTargetLanguagesChange = targetLanguages => {
    const max = this.props.translatedLanguageLimit
    if (this.state.targetLanguages && this.state.targetLanguages.length < max) {

        this.setState({ targetLanguages })
    }
  }

  handleTargetLanguagesRemove = targetLanguage => {
      const targetLanguages = this.state.targetLanguages
      const index = targetLanguages.indexOf(targetLanguage)

      if (index > -1) {
          targetLanguages.splice(index, 1);
          this.setState({ targetLanguages })
      }

  }

  render() {
    // all language list
    const { form, button, translatedLanguageLimit } = this.props

    //States values
    let { sourceLanguage, targetLanguages } = this.props

    if(!sourceLanguage)
        sourceLanguage = this.state.sourceLanguage

    if(!targetLanguages)
        targetLanguages = this.state.targetLanguages

    let filteredTargetLanguages = {}

    //We need to filter and remove already present langs
    for(var lang in languages) {
        if (languages.hasOwnProperty(lang) && !targetLanguages.includes(lang)) {
            filteredTargetLanguages[lang] = languages[lang];
        }
    }

    const sourceLanguageHtml =  Object.keys(languages).map((lang, index) => {
        const label = languages[lang]

        return (
            <Option key={index} value={lang} title={label}>
              {label}
            </Option>
        )
    })

    const targetLanguagesHtml = Object.keys(filteredTargetLanguages).map((lang, index) => {
      if (lang != sourceLanguage){
          const label = languages[lang]
          return (
            <Option key={lang} value={lang} title={label}>
              {label}
            </Option>
          )
      }
    })

    //We need to update this for the initial values
    targetLanguages = targetLanguages.map(lang => {
        return { key : lang, label : languages[lang] }
    })

    return (
      <div>
          <div>
            <FormItem label="Source Language" help="This is the current language of your site">
              {form.getFieldDecorator('sourceLanguage', {
                  initialValue : sourceLanguage || "",
                  rules: [{ required: true, message: 'Source Language is required' }],
              })(
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  onChange={this.handleSourceLanguageChange}
                  optionFilterProp="title"
                >
                  {sourceLanguageHtml}
                </Select>
              )}
            </FormItem>


             <FormItem label="Target languages" help="Choose the language(s) you want your site translated into" style={{marginTop : "25px"}}>
               {form.getFieldDecorator('targetLanguages', {
                   initialValue : targetLanguages || [],
                   rules: [
                       { required: true, message: 'Target Languages is required' },
                       {
                             validator: (rule, value, callback) => {
                                 let errors = []

                                 if (value && value.length > translatedLanguageLimit)
                                    errors.push('You have reached the limit of languages')

                                callback(errors)
                            },
                        },
                    ],

               })(
                 <Select
                   mode="multiple"
                   style={{ width: '100%' }}
                   onChange={this.handleTargetLanguagesChange}
                   onDeselect={this.handleTargetLanguagesRemove}
                   labelInValue
                   optionFilterProp="title"
                 >
                   {targetLanguagesHtml}
                 </Select>
               )}
             </FormItem>

          </div>
      </div>
    )
  }
}

export default LanguageSelection
